module.exports = __webpack_public_path__ + "img/2_86.25b06cb5.png";